<script>
    import { onMount, createEventDispatcher } from 'svelte';
    import { Categories } from '../../ui_elements/enums';
    import { getLocalStorageItem, isAdminUser } from '../../utility.js';
    import Button from '../../ui_elements/Button.svelte';
    export let questions;
    export let subcategoryID;
    export let categoryName;
    export let answers = {};
    export let isAdmin = false;
    export let showErrors = false;

    const dispatch = createEventDispatcher();
    var rating_systems = {
        [Categories.INTERESSEN]: {
            1: "interessiert mich gar nicht",
            2: "interessiert mich wenig",
            3: "interessiert mich mittel",
            4: "interessiert mich",
            5: "interessiert mich sehr"
        },
        [Categories.FAEHIGKEITEN]: {
            1: "stimme gar nicht zu",
            2: "stimme eher nicht zu",
            3: "mittel",
            4: "stimme schon zu",
            5: "stimme voll zu"
        },
        [Categories.SCHULFAECHER]: {
            1: "Nein",
            2: "Wäre ok",
            3: "Gerne"
        },
        [Categories.SCHULNOTEN]: {
            1: "1",
            2: "2",
            3: "3",
            4: "4",
            5: "5",
            6: "6",
            '/': "hatte ich noch nie",
        },
    };
    rating_systems[Categories.FEEDBACK] = rating_systems[Categories.FAEHIGKEITEN];

    function handleValueSelection(questionID, value) {
        answers[questionID] = value;
        dispatchAnswerChange(); 
    }

    function loadSavedAnswers() {
        const questionnaireAnswers = getLocalStorageItem('questionnaireAnswers') || {};
        answers = questionnaireAnswers[subcategoryID] || {};
        dispatchAnswerChange(); 
    }

    function setAnswers() {
        questions.forEach(question => {
            answers[question.question_id] = Object.keys(rating_systems[categoryName])[0];
        });

        dispatchAnswerChange();
    }

    function dispatchAnswerChange() {
        dispatch('answerChange', { answers, subcategoryID });
    }

    onMount(() => {
        loadSavedAnswers();
    });
</script>


<div class="border border-secondary border-collapse rounded-lg">
    <table class="border-hidden table-fixed w-[100%] text-secondary-text">
        
        <thead class="text-xs text-secondary-text-light uppercase font-semibold">
            <th class="border border-secondary p-1 w-[3%]">#</th>
            <th class="border border-secondary p-1 w-[45%]">Frage</th>
            {#each Object.entries(rating_systems[categoryName]) as [key, value]}
                <th class="border border-secondary p-1">{value}</th>
            {/each}
        </thead>
        
        {#if questions}
            {#each questions as question, index}
                {#key showErrors && answers}
                    <tr class="{index % 2 === 0 ? 'bg-accent-light' : 'bg-accent-very-light'} {(!answers[question.question_id] && showErrors) ? 'text-red-600' : ''} hover:bg-accent-hover">
                        <td class="border border-secondary p-1 text-center font-semibold">{index + 1}</td>
                        <td class="border border-secondary p-1">{question.question_text}</td>

                        {#each Object.entries(rating_systems[categoryName]) as [key, value]}
                            <td class="border border-secondary p-1 text-center cursor-pointer transition-colors hover:bg-accent {answers[question.question_id] === key ? 'bg-accent-border' : ''} font-semibold" on:click={() => {handleValueSelection(question.question_id, key)}}>
                                <input type="radio" name={question.question_id} value={key} bind:group={answers[question.question_id]} class="text-accent-highlight bg-secondary-light border-secondary focus:ring-accent-light">
                                <label class="radio-label" for={question.question_id}>{key}</label>
                            </td>
                        {/each}
                    </tr>
                {/key}
            {/each}
        {/if}

    </table>
</div>

{#if isAdmin}
    <div>
        <Button className="mt-1" on:click={setAnswers}>DEBUG: SET ALL ANSWERS</Button>
    </div>
{/if}

